module.exports = __webpack_public_path__ + "img/逗你玩_礼物.b726862c.png";